
const digest = '26bbe3aa7f7b6c4079d36b72b7eb53bb3d12d69e4a02496fb3ee367f47122d00';
const classes = {"container":"_container_tklql_1","buttonsContainer":"_buttonsContainer_tklql_7"};
const css = `._container_tklql_1 {
  display: flex;
  flex-direction: row;
  flex: 1;
}

._buttonsContainer_tklql_7 {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  